import TableContainer from "../../../_table-container";
import { TechnicalStatuses } from "../../../../constants/technical_statuses";
import { mapState, mapActions } from "vuex";
import LoadingModal from '@/components/_modals/loading';


export default {
  name: "TechnicalStatusesTable",
  props: { searchText: String, tableTitle: String, selectedFilter: Object },
  components: { TableContainer, LoadingModal },
  async mounted () {
    this.getGatewayStatuses();
    this.getCowsNotSeen();
    this.getCowsWithHighPM();
  },
  data(){
    return{
      sortBy: {
        key: "gateway_name",
        direction: false
      },
      cowsNotSeenHeaders: [
        {
          sortByKey: "eartag",
          text: this.$t("cowGenerics.eartag")
        },
        {
          sortByKey: "last_seen",
          text: this.$t("dashboardView.listHeader.lastSeen")
        },
      ],
      cowsWithHighPMHeaders: [
        {
          sortByKey: "eartag",
          text: this.$t("cowGenerics.eartag")
        },
        {
          sortByKey: "pending_msg",
          text: this.$t("dashboardView.listHeader.pendingMsgs")
        },
      ],
      gatewayHeaders: [
        {
          sortByKey: "status",
          text: this.$t('gateway.status')
        },  
        {
          sortByKey: "gateway_name",
          text: this.$t('gateway.name')
        },
      ],
      headers: []
    }
  },
  computed: {
    ...mapState({
      /**
       * The computed data for the table
       * @param {object} state The state object
       */
      tableData(state) {
        if(!this.selectedFilter)
          return []

        var t_data = []

        if(this.selectedFilter.filter === TechnicalStatuses.GatewayStatus){
          t_data = state.technicalStatuses.gateways.filter(gateway => gateway.status != null).map(gw => {return {...gw, id: gw.gateway_name}})
        }else if(this.selectedFilter.filter === TechnicalStatuses.CowsNotSeen){
          t_data = state.technicalStatuses.cowsNotSeen.map(cow => {return {...cow, id: cow.cow_id, last_seen_days: this.getLastSeen(cow.last_seen)}})
        }else{
          t_data = state.technicalStatuses.cowsWithHighPM.map(cow => { return {...cow, id: cow.cow_id}})
        }

        const data = this.sortData(t_data)

        return data
      },
      isGatewayStatus(){
        if(!this.selectedFilter){
          return false;
        }
        return this.selectedFilter.filter == TechnicalStatuses.GatewayStatus
      },
      isCowsNotSeen(){
        if(!this.selectedFilter){
          return false;
        }
        return this.selectedFilter.filter == TechnicalStatuses.CowsNotSeen
      },
      isCowsWithHighPM(){
        if(!this.selectedFilter){
          return false;
        }
        return this.selectedFilter.filter == TechnicalStatuses.CowsWithHighPm
      },
      isFetching: state => state.technicalStatuses.isFetching,
    })
  },
  watch: {
    selectedFilter: function (newVal) {
      if (newVal.filter === TechnicalStatuses.GatewayStatus){
        this.headers = this.gatewayHeaders;
      }else if(newVal.filter === TechnicalStatuses.CowsNotSeen){
        this.headers = this.cowsNotSeenHeaders;
      }else{
        this.headers = this.cowsWithHighPMHeaders;
      }
    }
  },
  methods: {
    ...mapActions("cows", {
      setCowList: "setCowList",
    }),
    ...mapActions("technicalStatuses", {
      manageGateways: "manageGateways",
      getGatewayStatuses: "getGatewayStatuses",
      getCowsNotSeen: "getCowsNotSeen",
      getCowsWithHighPM: "getCowsWithHighPM"
    }),
    setSortBy(sortBy) {
      this.sortBy.direction = !this.sortBy.direction;
      this.sortBy.key = sortBy;
    },
    async refresh(){
      await this.manageGateways()
      this.getGatewayStatuses()
    },
    /**
     * Sorts the data by cow_id in ascending order (smallest in front)
     * @param {array} data data to sort
     */
    sortData(cows) {
      return cows.sort((a, b) => {

        // Get values by keys
        let aKey, bKey;
        aKey = a ? a[this.sortBy.key] : null;
        bKey = b ? b[this.sortBy.key] : null;

        if(this.sortBy.key == "last_seen"){
          aKey = this.$moment(b.last_seen || '2000-01-01').format('x')
          bKey = this.$moment(a.last_seen || '2000-01-01').format('x')
        }

        //Compare numerical values
        let diff = aKey - bKey;

        // Compare strings
        if (['eartag', 'gateway_name'].includes(this.sortBy.key)){
          // Check for direction(string)
          if (this.sortBy.direction)
            diff = (bKey || '').localeCompare(aKey)
          else
            diff = (aKey || '').localeCompare(bKey)
        }
        else
          // Numerical, check for direction
          if (this.sortBy.direction)
            diff *= -1;

        return diff;
      })
    },

    getLastSeen(dateString) {
      if (!dateString) {
        return this.$t("general.never").toUpperCase();
      }

      const dateTime = this.$moment(dateString);

      const now = this.$moment();

      const diff = now - dateTime;

      const diffInDays = Math.ceil(diff / 1000 / 60 / 60 / 24);

      if (diffInDays === 1) {
        const diffInHours = Math.ceil(diff / 1000 / 60 / 60);
        if (diffInHours === 1) {
          const diffInMinutes = Math.ceil(diff / 1000 / 60);
          return `${diffInMinutes} minutes ago`;
        }
        return `${diffInHours} hours ago`;
      }

      return `${diffInDays} days ago`;
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/technical-status/table/technical-status-table.js